module.exports = __webpack_public_path__ + "static/img/min-irrigation.4c64489.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/min-irrigation.png
// module id = 871
// module chunks = 0